// extracted by css-extract-rspack-plugin
export default {"grid":"_df14c67d","tileWidth":"_e0e51fd7","ctaWrapper":"_2fd3cfe0","buttonText":"_51c18eae"};